import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { CtaButton } from '@tkww/orion-web-ds-action';
import React, { type FC } from 'react';
import { GoogleReview } from '../google_review/GoogleReview';
import Styles from './GoogleReviewsWrapper.scss';

export interface OwnProps {
	googleReviews: {
		id: string;
		authorName: string;
		publicProfilePicture: string;
		publishedAt: string;
		rating: number;
		reviewText: string;
	}[];
	googleReviewsLink: string;
}

type Props = OwnProps;

export const GoogleReviewsWrapper: FC<Props> = ({
	googleReviews,
	googleReviewsLink,
}) => {
	const { track } = useAnalyticsContext();

	const trackOnclickSeeAllGoogleReviews = () => {
		track({
			event: 'Review Interaction',
			properties: {
				action: 'Click See All Google Reviews',
			},
		});
	};

	return (
		<div
			className={Styles.googleReviewsWrapper}
			data-testid="google-reviews-wrapper"
		>
			{googleReviews.map((review) => (
				<GoogleReview
					key={review.id}
					authorName={review.authorName}
					publicProfilePicture={review.publicProfilePicture}
					publishedAt={review.publishedAt}
					rating={review.rating}
					reviewText={review.reviewText}
				/>
			))}

			<CtaButton
				as="a"
				styleType="secondary"
				size="md"
				iconName="link-out"
				labelDirection="left"
				className={Styles.seeAllGoogleReviews}
				target="_blank"
				rel="noreferrer noopener nofollow"
				onClick={() => {
					trackOnclickSeeAllGoogleReviews();
				}}
				href={googleReviewsLink}
			>
				See all Google reviews
			</CtaButton>
		</div>
	);
};
